export default __webpack_public_path__ + "static/media/pageLoader.cf954b00.gif";